import { render, staticRenderFns } from "./EditSupplierProductSetting.vue?vue&type=template&id=65384d9e&scoped=true&"
import script from "./EditSupplierProductSetting.vue?vue&type=script&lang=js&"
export * from "./EditSupplierProductSetting.vue?vue&type=script&lang=js&"
import style0 from "./EditSupplierProductSetting.vue?vue&type=style&index=0&id=65384d9e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65384d9e",
  null
  
)

export default component.exports